import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=2a43441c&scoped=true"
import script from "./OrderLayout.vue?vue&type=script&lang=js"
export * from "./OrderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a43441c",
  null
  
)

export default component.exports